



















import React, { useState, useEffect, useMemo } from "react";
import { Spinner, Form, Button, Dropdown, Table, Pagination, Card, Badge, InputGroup } from "react-bootstrap";
import * as XLSX from 'xlsx';
import { FaSearch, FaTimes } from 'react-icons/fa';

const Record = (props) => (
  <tr>
    <td>{props.record.name}</td>
    <td>{props.record.code}</td>
    <td>{props.record.scripname}</td>
    <td>{props.record.exchange}</td>
    <td>{props.record.segment}</td>
    <td>{props.record.buy_sell}</td>
    <td>{props.record.rate}</td>
    <td>{props.record.tradedqty}</td>
    <td>{props.record.stk}</td>
    <td>{props.record.pre}</td>
    <td>{props.record.amount}</td>
    <td>{props.record.tradedate}</td>
    <td>{props.record.orderno}</td>
    <td>{props.record.tradeno}</td>
    <td>{props.record.tradetime}</td>
    <td>{props.record.locnid}</td>
  </tr>
);

export default function Trades() {
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [codes, setCodes] = useState('');
  const [selectedScripnames, setSelectedScripnames] = useState([]);
  const [exchange, setExchange] = useState('');
  const [segment, setSegment] = useState('');
  const [buySell, setBuySell] = useState('');
  const [allRecords, setAllRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [scripSearch, setScripSearch] = useState('');

  const fetchDataByDate = async () => {
    if (!fromDate && !toDate) {
      alert("Please select at least one date");
      return;
    }

    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (fromDate) params.append('fromDate', fromDate);
      if (toDate) params.append('toDate', toDate);

      const response = await fetch(`http://183.182.84.228:4005/tradeslip/?${params.toString()}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      setAllRecords(data);
      setFilteredRecords(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const applyFrontendFilters = () => {
    let filtered = [...allRecords];
    
    if (selectedScripnames.length > 0) {
      filtered = filtered.filter(record => 
        selectedScripnames.includes(record.scripname)
      );
    }
    
    if (codes) {
      const codeList = codes.split(',').map(code => code.trim());
      filtered = filtered.filter(record => 
        codeList.includes(record.code)
      );
    }
    
    if (exchange) {
      filtered = filtered.filter(record => 
        record.exchange === exchange
      );
    }
    
    if (segment) {
      filtered = filtered.filter(record => 
        record.segment === segment
      );
    }
    
    // if (buySell) {
    //   filtered = filtered.filter(record => 
    //     record.buy_sell === buySell
    //   );
    // }

    if (buySell) {
      filtered = filtered.filter(record => {
        const normalizedRecordValue = record.buy_sell?.charAt(0).toUpperCase();
        const normalizedFilterValue = buySell.charAt(0).toUpperCase();
        return normalizedRecordValue === normalizedFilterValue;
      });
    }
    
    setFilteredRecords(filtered);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (allRecords.length > 0) {
      applyFrontendFilters();
    }
  }, [selectedScripnames, codes, exchange, segment, buySell, allRecords]);

  const handleDownload = () => {
    if (filteredRecords.length === 0) {
      alert("No data to download");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(filteredRecords);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "TradeRecords");
    XLSX.writeFile(wb, `trade_records_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  const handleClearFilters = () => {
    setCodes('');
    setSelectedScripnames([]);
    setExchange('');
    setSegment('');
    setBuySell('');
    setFilteredRecords(allRecords);
  };

  // Enhanced scripname filter logic
  const uniqueScripnames = useMemo(() => 
    [...new Set(allRecords.map(item => item.scripname))].sort(), 
    [allRecords]
  );

  const filteredScripnames = useMemo(() => 
    uniqueScripnames.filter(scrip => 
      scrip && scrip.toLowerCase().includes(scripSearch.toLowerCase())
    ),
    [uniqueScripnames, scripSearch]
  );

  const handleSelectAllScrips = () => {
    if (selectedScripnames.length === filteredScripnames.length) {
      setSelectedScripnames([]);
    } else {
      setSelectedScripnames(filteredScripnames);
    }
  };

  const handleClearScripSearch = () => {
    setScripSearch('');
  };

  const paginatedRecords = filteredRecords.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const totalPages = Math.ceil(filteredRecords.length / pageSize);

  const uniqueExchanges = [...new Set(allRecords.map(item => item.exchange))].sort();
  const uniqueSegments = [...new Set(allRecords.map(item => item.segment))].sort();
  const uniqueBuySell = [...new Set(allRecords.map(item => item.buy_sell))].sort();
  const uniqueCodes = [...new Set(allRecords.map(item => item.code))].sort();

  return (
    // <div className="container mt-4">
      <div>
      <Card>
        <Card.Header>
          <h4>Trade Records Filter</h4>
        </Card.Header>
        <Card.Body>
          {/* Date Filter Section */}
          <div className="row g-3">
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Form.Group>
            </div>
            <div className="col-md-3">
              <Form.Group>
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  min={fromDate}
                />
              </Form.Group>
            </div>
            <div className="col-md-3 d-flex align-items-end">
              <Button
                variant="primary"
                onClick={fetchDataByDate}
                disabled={loading || (!fromDate && !toDate)}
              >
                {loading ? (
                  <>
                    <Spinner as="span" size="sm" animation="border" />
                    <span className="ms-2">Loading...</span>
                  </>
                ) : (
                  "Fetch Data"
                )}
              </Button>
            </div>
          </div>

          {/* Frontend Filters Section */}
          {allRecords.length > 0 && (
            <>
              <div className="row g-3 mt-3">
                <div className="col-md-4">
                  <Form.Group>
                    <Form.Label>Scripnames</Form.Label>
                    <Dropdown className="" style={{display:"block"}}>
                      <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center" style={{margin: 0}}>
                        <span>
                          {selectedScripnames.length > 0
                            ? `${selectedScripnames.length} selected`
                            : "Select scripnames"}
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <div className="p-2">
                          <InputGroup>
                            <InputGroup.Text>
                              <FaSearch />
                            </InputGroup.Text>
                            <Form.Control
                              type="text"
                              placeholder="Search scripnames..."
                              value={scripSearch}
                              onChange={(e) => setScripSearch(e.target.value)}
                            />
                            {scripSearch && (
                              <Button
                                variant="outline-secondary"
                                onClick={handleClearScripSearch}
                              >
                                <FaTimes />
                              </Button>
                            )}
                          </InputGroup>
                        </div>
                        <div className="d-flex justify-content-between px-2 pb-2 border-bottom">
                          <Button
                            variant="link"
                            size="sm"
                            onClick={handleSelectAllScrips}
                          >
                            {selectedScripnames.length === filteredScripnames.length 
                              ? "Clear all" 
                              : "Select all"}
                          </Button>
                          <Button
                            variant="link"
                            size="sm"
                            onClick={() => setSelectedScripnames([])}
                          >
                            Clear selection
                          </Button>
                        </div>
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                          {filteredScripnames.map((scrip, idx) => (
                            <Dropdown.Item key={idx} as="div">
                              <Form.Check
                                type="checkbox"
                                id={`scrip-${idx}`}
                                label={scrip}
                                checked={selectedScripnames.includes(scrip)}
                                onChange={() => setSelectedScripnames(prev =>
                                  prev.includes(scrip)
                                    ? prev.filter(s => s !== scrip)
                                    : [...prev, scrip]
                                )}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </Dropdown.Item>
                          ))}
                          {filteredScripnames.length === 0 && (
                            <Dropdown.Item disabled>
                              No matching scripnames found
                            </Dropdown.Item>
                          )}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Form.Group>
                </div>
                <div className="col-md-2">
                  <Form.Group>
                    <Form.Label>Exchange</Form.Label>
                    <Form.Select
                      value={exchange}
                      onChange={(e) => setExchange(e.target.value)}
                    >
                      <option value="">All Exchanges</option>
                      {uniqueExchanges.map((ex, idx) => (
                        <option key={idx} value={ex}>{ex}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-2">
                  <Form.Group>
                    <Form.Label>Segment</Form.Label>
                    <Form.Select
                      value={segment}
                      onChange={(e) => setSegment(e.target.value)}
                    >
                      <option value="">All Segments</option>
                      {uniqueSegments.map((seg, idx) => (
                        <option key={idx} value={seg}>{seg}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
                {/* <div className="col-md-2">
                  <Form.Group>
                    <Form.Label>Buy/Sell</Form.Label>
                    <Form.Select
                      value={buySell}
                      onChange={(e) => setBuySell(e.target.value)}
                    >
                      <option value="">All</option>
                      {uniqueBuySell.map((bs, idx) => (
                        <option key={idx} value={bs}>{bs}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div> */}

              <div className="col-md-2">
                <Form.Group>
                  <Form.Label>Buy/Sell</Form.Label>
                  <Form.Select
                    value={buySell}
                    onChange={(e) => setBuySell(e.target.value)}
                  >
                    <option value="">All</option>
                    <option value="B">B / Buy</option>
                    <option value="S">S / Sell</option>
                  </Form.Select>
                </Form.Group>
              </div>
                <div className="col-md-2">
                  <Form.Group>
                    <Form.Label>Codes</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="ABC123, DEF456"
                      value={codes}
                      onChange={(e) => setCodes(e.target.value)}
                      list="codeOptions"
                      style={{margin: 0}}
                    />
                    <datalist id="codeOptions">
                      {uniqueCodes.map((code, idx) => (
                        <option key={idx} value={code} />
                      ))}
                    </datalist>
                  </Form.Group>
                </div>
              </div>

              <div className="d-flex gap-2 mt-3">
                <Button variant="outline-secondary" onClick={handleClearFilters}>
                  Clear All Filters
                </Button>
                <Button variant="success" onClick={handleDownload}>
                  Download Excel
                </Button>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Results Table */}
      {filteredRecords.length > 0 && (
        <div className="mt-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5>Trade Records</h5>
              <Badge bg="primary">
                Total Records: {filteredRecords.length}
              </Badge>
            </Card.Header>
            <Card.Body>
              <div className="d-flex justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  <span className="me-2">Show</span>
                  <Form.Select
                    size="sm"
                    style={{ width: '80px' }}
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </Form.Select>
                  <span className="ms-2">entries</span>
                </div>
              </div>

              <div 
  className="table-responsive rounded-3 shadow-sm border-0"
  style={{
    maxHeight: 'calc(100vh - 250px)',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
  }}
>
  <Table striped bordered hover className="mb-0" style={{ tableLayout: 'auto' }}>
    <colgroup>
      <col style={{ width: 'auto' }} /> {/* Name */}
      <col style={{ width: 'auto' }} /> {/* Code */}
      <col style={{ width: 'auto' }} /> {/* Scrip Name */}
      <col style={{ width: 'auto' }} /> {/* Exchange */}
      <col style={{ width: 'auto' }} /> {/* Segment */}
      <col style={{ width: '100px' }} /> {/* Buy/Sell - Fixed width for consistency */}
      <col style={{ width: 'auto' }} /> {/* Rate */}
      <col style={{ width: 'auto' }} /> {/* Traded Qty */}
      <col style={{ width: 'auto' }} /> {/* STK */}
      <col style={{ width: 'auto' }} /> {/* PRE */}
      <col style={{ width: 'auto' }} /> {/* Amount */}
      <col style={{ width: '120px' }} /> {/* Trade Date - Fixed width */}
      <col style={{ width: 'auto' }} /> {/* Order No */}
      <col style={{ width: 'auto' }} /> {/* Trade No */}
      <col style={{ width: '120px' }} /> {/* Trade Time - Fixed width */}
      <col style={{ width: 'auto' }} /> {/* Location ID */}
    </colgroup>
    <thead style={{
      position: 'sticky',
      top: 0,
      zIndex: 10,
      backgroundColor: 'white',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    }}>
      <tr className="align-middle">
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Name</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Code</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Scrip Name</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Exchange</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Segment</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Buy/Sell</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Rate</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Traded Qty</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">STK</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">PRE</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Amount</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Trade Date</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Order No</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Trade No</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Trade Time</th>
        <th className="py-3 px-3 bg-light text-uppercase fw-semibold text-muted fs-sm text-truncate">Location ID</th>
      </tr>
    </thead>
    <tbody className="border-top-0">
      {paginatedRecords.map((record, index) => (
        <tr key={index} className="align-middle">
          <td className="py-2 px-3 text-truncate small" style={{ maxWidth: '100px' }} title={record.name}>{record.name}</td>
          <td className="py-2 px-3 text-truncate" style={{ maxWidth: '100px' }} title={record.code}>{record.code}</td>
          <td className="py-2 px-3 text-truncate" style={{ maxWidth: '150px' }} title={record.scripname}>{record.scripname}</td>
          <td className="py-2 px-3 text-truncate" style={{ maxWidth: '100px' }} title={record.exchange}>{record.exchange}</td>
          <td className="py-2 px-3 text-truncate" style={{ maxWidth: '100px' }} title={record.segment}>{record.segment}</td>
          <td className="py-2 px-3 text-center">
            <span className={`badge rounded-pill d-inline-flex align-items-center justify-content-center ${
              record.buy_sell?.toUpperCase().startsWith('B')
                ? 'bg-success bg-opacity-10 text-success border border-success border-opacity-25'
                : 'bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25'
            }`} style={{ 
              padding: '0.25rem 0.75rem',
              minWidth: '60px'
            }}>
              {record.buy_sell?.toUpperCase() === 'B' ? 'BUY' : 
               record.buy_sell?.toUpperCase() === 'S' ? 'SELL' : 
               record.buy_sell}
            </span>
          </td>
          <td className="py-2 px-3 text-end">{record.rate}</td>
          <td className="py-2 px-3 text-end">{record.tradedqty}</td>
          <td className="py-2 px-3">{record.stk}</td>
          <td className="py-2 px-3">{record.pre}</td>
          <td className="py-2 px-3 text-end fw-semibold">{record.amount.toFixed(2)}</td>
          <td className="py-2 px-3 text-nowrap">{record.tradedate}</td>
          <td className="py-2 px-3 text-truncate" style={{ maxWidth: '120px' }} title={record.orderno}>{record.orderno}</td>
          <td className="py-2 px-3 text-truncate" style={{ maxWidth: '120px' }} title={record.tradeno}>{record.tradeno}</td>
          <td className="py-2 px-3 text-nowrap">{record.tradetime}</td>
          <td className="py-2 px-3 text-truncate" style={{ maxWidth: '120px' }} title={record.locnid}>{record.locnid}</td>
        </tr>
      ))}
    </tbody>
  </Table>
</div>

              <div className="d-flex justify-content-between mt-3">
                <div>
                  Showing {((currentPage - 1) * pageSize) + 1} to{' '}
                  {Math.min(currentPage * pageSize, filteredRecords.length)} of{' '}
                  {filteredRecords.length} entries
                </div>
                <Pagination>
  <Pagination.First 
    onClick={() => setCurrentPage(1)} 
    disabled={currentPage === 1} 
  />
  <Pagination.Prev 
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
    disabled={currentPage === 1} 
  />
  
  {/* Display current page/total pages instead of all page numbers */}
  <Pagination.Item disabled>
    Page {currentPage} of {totalPages}
  </Pagination.Item>
  
  <Pagination.Next 
    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
    disabled={currentPage === totalPages} 
  />
  <Pagination.Last 
    onClick={() => setCurrentPage(totalPages)} 
    disabled={currentPage === totalPages} 
  />
</Pagination>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
    </div>
  );
}
























































// import React, { useEffect, useState } from "react";
// import * as XLSX from 'xlsx';
// import { Spinner } from "react-bootstrap";

// const Record = (props) => (
//   <tr>
//     <td>{props.record.name}</td>
//     <td>{props.record.code}</td>
//     <td>{props.record.scripname}</td>
//     <td>{props.record.exchange}</td>
//     <td>{props.record.segment}</td>
//     <td>{props.record.buy_sell}</td>
//     <td>{props.record.rate}</td>
//     <td>{props.record.tradedqty}</td>
//     <td>{props.record.stk}</td>
//     <td>{props.record.pre}</td>
//     <td>{props.record.amount}</td>
//     <td>{props.record.tradedate}</td>
//     <td>{props.record.orderno}</td>
//     <td>{props.record.tradeno}</td>
//     <td>{props.record.tradetime}</td>
//     <td>{props.record.locnid}</td>
//   </tr>
// );

// export default function Trades() {
//   const [loading, setLoading] = useState(false);
//   const [records, setRecords] = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [code, setCode] = useState('');
//   const [scripname, setScripname] = useState(''); // New state for scripname
//   const [filteredRecords, setFilteredRecords] = useState([]);
//   const [previewMode, setPreviewMode] = useState(false);
//   const [pageSize, setPageSize] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     async function getRecords() {
//       setLoading(true);
//       try {
//         const response = await fetch(`http://183.182.84.228:4005/tradeslip/`);
//         if (!response.ok) {
//           const message = `An error occurred: ${response.statusText}`;
//           window.alert(message);
//           setLoading(false);
//           return;
//         }
//         const records = await response.json();
//         setRecords(records);
//       } catch (error) {
//         const message = `An error occurred: ${error.message}`;
//         window.alert(message);
//       } finally {
//         setLoading(false);
//       }
//     }
//     getRecords();
//   }, []);

//   const uniqueDates = Array.from(new Set(records.map(record => record.tradedate)));
//   const uniqueCodes = Array.from(new Set(records.map(record => record.code)));
//   const uniqueScripnames = Array.from(new Set(records.map(record => record.scripname))); // Unique scripnames

//   function handleFilter() {
//     if (!selectedDate && !code && !scripname) {
//       alert("Please select a date, scripname, or enter a code to filter records.");
//       return;
//     }

//     const filtered = records.filter(record => {
//       const dateMatches = selectedDate ? record.tradedate === selectedDate : true;
//       const codeMatches = code ? record.code === code : true;
//       const scripnameMatches = scripname ? record.scripname === scripname : true;
//       return dateMatches && codeMatches && scripnameMatches;
//     });

//     setFilteredRecords(filtered);
//     setPreviewMode(true);
//     setCurrentPage(1);
//   }

//   const paginatedRecords = filteredRecords.slice((currentPage - 1) * pageSize, currentPage * pageSize);
//   const totalPages = Math.ceil(filteredRecords.length / pageSize);

//   function handlePageSizeChange(e) {
//     setPageSize(Number(e.target.value));
//     setCurrentPage(1);
//   }

//   function handlePageChange(newPage) {
//     setCurrentPage(newPage);
//   }

//   function handleDownload() {
//     const sheetName = 'Filtered Records';
//     const currentDate = new Date();
//     const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
//     const wb = XLSX.utils.book_new();
//     const data = [
//       ["Sno.", "name",	"code",	"scripname",	"exchange",	"segment",	"buy_sell",	"rate",	"tradedqty",	"stk",	"pre",	"amount",	"tradedate",	"orderno",	"tradeno",	"tradetime"],
//       ...filteredRecords.map((record, index) => [
//         index + 1, record.name,	record.code,	record.scripname,	record.exchange,	record.segment,	record.buy_sell,	record.rate,	record.tradedqty,	record.stk,	record.pre,	record.amount,	record.tradedate,	record.orderno,	record.tradeno,	record.tradetime
//       ]),
//     ];
//     const ws = XLSX.utils.aoa_to_sheet(data);
//     XLSX.utils.book_append_sheet(wb, ws, sheetName);
//     XLSX.writeFile(wb, `Trade_Records_${formattedDate}.xlsx`);
//   }

//   return (
//     <div>
//       {!previewMode && (
//         <>
//           <h3>Trades Details</h3>
//           <label>Select Date: </label>
//           <select value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}>
//             <option value="">-- Select Date --</option>
//             {uniqueDates.map((date, index) => (
//               <option key={index} value={date}>
//                 {date}
//               </option>
//             ))}
//           </select>
//           &nbsp;&nbsp;
//           <label>Scripname: </label>
//           <input
//             type="text"
//             value={scripname}
//             placeholder="Enter scripname"
//             onChange={(e) => setScripname(e.target.value)}
//             list="scripnameOptions"
//           />
//           <datalist id="scripnameOptions">
//             {uniqueScripnames.map((uniqueScrip, index) => (
//               <option key={index} value={uniqueScrip} />
//             ))}
//           </datalist>
//           &nbsp;&nbsp;
//           <label>Code: </label>
//           <input
//             type="text"
//             value={code}
//             placeholder="Enter code"
//             onChange={(e) => setCode(e.target.value)}
//             list="codeOptions"
//           />
//           <datalist id="codeOptions">
//             {uniqueCodes.map((uniqueCode, index) => (
//               <option key={index} value={uniqueCode} />
//             ))}
//           </datalist>
//           &nbsp;&nbsp;
//           <button onClick={handleFilter}>Submit</button>
//         </>
//       )}
//       {loading && (
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <Spinner animation="border" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </Spinner>
//         </div>
//       )}
//       {previewMode && (
//         <>
//           <button onClick={() => setPreviewMode(false)}>Back</button>
//           &nbsp;&nbsp;&nbsp;
//           <div>
//             <label>Records per page:</label>
//             <select value={pageSize} onChange={handlePageSizeChange}>
//               {[10, 20, 50, 100, 1000, 5000].map(size => (
//                 <option key={size} value={size}>{size}</option>
//               ))}
//             </select>
//             <div>
//               <button disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
//               <span>Page {currentPage} / {totalPages}</span>
//               <button disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>Next</button>
//             </div>
//             <table>
//               <thead>
//                 <tr>
//                   <th>name</th>
//                   <th>code</th>
//                   <th>scripname</th>
//                   <th>exchange</th>
//                   <th>segment</th>
//                   <th>buy_sell</th>
//                   <th>rate</th>
//                   <th>tradedqty</th>
//                   <th>stk</th>
//                   <th>pre</th>
//                   <th>amount</th>
//                   <th>tradedate</th>
//                   <th>orderno</th>
//                   <th>tradeno</th>
//                   <th>tradetime</th>
//                   <th>locnid</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {paginatedRecords.map((record) => (
//                   <Record record={record} key={record._id} />
//                 ))}
//               </tbody>
//             </table>
            
//           </div>
//         </>
//       )}
//     </div>
//   );
// }
